exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".personal-details-section__header{padding:16px 32px;display:flex;justify-content:space-between;align-items:center;background:#f5f7f7;border-bottom:1px solid #d2d8db}.personal-details-section__title{margin:0}.personal-details-section__body{padding:32px}.personal-details-section__toggle-button{font-size:100%;border:0;padding:0;background-color:rgba(0,0,0,0);width:24px;height:24px}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};